<template>
  <div>
    <h1>Actualizar Concesión</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Concesionario">
                <v-select label="name" disabled :options="getConcesionarios" v-model="$v.editConcesion.concesionarioId.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.editConcesion.concesionarioId.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Geocerca">
                <v-select label="name" :options="getAllGeofences" v-model="$v.editConcesion.geocerca.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <small class="text-danger" v-if="!$v.editConcesion.geocerca.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Concesión">
                <a-input
                  placeholder="Número de Concesión"
                  disabled
                  v-model="$v.editConcesion.concesionNumber.$model"
                />
                <small class="text-danger" v-if="!$v.editConcesion.concesionNumber.required">Campo requerido. No debe estar vacío.</small>
                <small class="text-danger" v-if="!$v.editConcesion.concesionNumber.numeric">Ingresa un número válido</small>
                <small class="text-danger" v-if="!$v.editConcesion.concesionNumber.maxLength">Ingresa un número menor o igual a diez caracteres</small>
                <small class="text-danger" v-if="!validateRegisteredConcesion($v.editConcesion.concesionNumber.$model)">Ya existe una registro con este número de concesión</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="¿Pertenece a un sitio?">
                <a-checkbox v-model="siteYes" @click="cleanSite()">
                  sitio
                </a-checkbox>
              </a-form-item>
            </div>
            <div v-if="siteYes===true" class="col-md-6">
              <a-form-item label="Sitio">
                <v-select label="name" :options="getAllSites" v-model="$v.editConcesion.siteId.$model"><span slot="no-options">Elemento no encontrado</span></v-select>
                <!-- <small class="text-danger" v-if="!$v.editConcesion.siteId.required">Campo requerido. No debe estar vacío.</small> -->
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredConcesion($v.editConcesion.concesionNumber.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import { required, numeric, maxLength } from 'vuelidate/lib/validators'
import headers from '@/config/headers.js'
const GET_CONCESIONES_QUERY = gql`
  query getAllConceciones{
    getAllConceciones{
      id
      concesionNumber
    }
  }
`
const GET_GEOCERCAS = gql`
  query getAllGeofences{
    getAllGeofences{
      id
      name
    }
  }
`
const GET_SITES = gql`
  query getAllSites{
     getAllSites{
      id
      name
    }
  }
`
const GET_CONCESIONARIOS = gql`
  query getConcesionarios{
    getConcesionarios{
      id
      name
    }
  }
`
const UPDATE_CONCESION = gql`
  mutation updateConcesion($id: Int, $geofenceId: Int, $siteId: Int){
    updateConcesion(id: $id, concesionUpdate: {
      geofenceId: $geofenceId
      siteId: $siteId
    }){
      id
      concesionNumber
      geofenceId
      siteId
      concesionario{
        id
        name
        rfc
      }
    }
  }
`
export default {
  data() {
    return {
      form: this.$form.createForm(this),
      id: this.$route.params.id,
      editConcesion: {
        concesionNumber: this.$route.params.concesionNumber,
        concesionarioId: this.$route.params.concesionario,
        geocerca: null,
        siteId: this.$route.params.siteId,
      },
      siteYes: false,
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredConcesiones: {},
      getAllGeofences: [],
      geofences: {},
      getConcesionarios: [],
      getAllSites: [],
      sites: {},
    }
  },
  apollo: {
    getConcesionarios: {
      query: GET_CONCESIONARIOS,
      result({ data }) {
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllGeofences: {
      query: GET_GEOCERCAS,
      result({ data }) {
        // console.log('geocercas')
        // console.log(data)
        data.getAllGeofences.forEach(geocerca => {
          // console.log(geocerca)
          this.geofences[geocerca.id] = geocerca
        })
        this.editConcesion.geocerca = this.geofences[this.$route.params.geofenceId]
        // this.editConcesion.
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllSites: {
      query: GET_SITES,
      result({ data }) {
        // console.log('geocercas')
        // console.log(data)
        data.getAllSites.forEach(siteId => {
          // consositeId)
          this.sites[siteId.id] = siteId
        })
        if (this.$route.params.siteId !== null) {
          this.editConcesion.siteId = this.sites[this.$route.params.siteId]
        }
        // this.editConcesion.
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
    getAllConceciones: {
      query: GET_CONCESIONES_QUERY,
      result({ data }) {
        // console.log('concesiones')
        data.getAllConceciones.forEach(concesion => {
          // console.log(concesion.concesionNumber)
          if (concesion.concesionNumber) {
            this.registeredConcesiones[concesion.concesionNumber] = 1
          }
        })
        delete this.registeredConcesiones[this.$route.params.concesionNumber]
      },
      error(error) {
        console.log(error)
      },
      context: headers(),
    },
  },
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    validateRegisteredConcesion(concesionNumber) {
      if (this.registeredConcesiones[concesionNumber]) {
        return false
      } else {
        return true
      }
    },
    cleanSite() {
      this.editConcesion.siteId = null
    },
    handleSubmit() {
      console.log('edit concesion')
      console.log(this.editConcesion)
      if (this.editConcesion.siteId === null) {
        this.$apollo.mutate({
          mutation: UPDATE_CONCESION,
          variables: {
            id: parseInt(this.id),
            // concesionNumber: parseInt(this.editConcesion.concesionNumber),
            // concesionarioId: parseInt(this.editConcesion.concesionarioId.id),
            geofenceId: parseInt(this.editConcesion.geocerca.id),
            siteId: null,
          },
          context: headers(),
        })
          .then(data => {
            console.log(data)
            this.$router.push('/concessions/getConcessions')
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        this.$apollo.mutate({
          mutation: UPDATE_CONCESION,
          variables: {
            id: parseInt(this.id),
            // concesionNumber: parseInt(this.editConcesion.concesionNumber),
            // concesionarioId: parseInt(this.editConcesion.concesionarioId.id),
            geofenceId: parseInt(this.editConcesion.geocerca.id),
            siteId: parseInt(this.editConcesion.siteId.id),
          },
          context: headers(),
        })
          .then(data => {
            console.log(data)
            this.$router.push('/concessions/getConcessions')
          })
          .catch(error => {
            console.log(error)
          })
      }
    },
  },
  validations: {
    editConcesion: {
      concesionNumber: { required, numeric, maxLength: maxLength(20) },
      concesionarioId: { required },
      geocerca: { required },
      siteId: {},
    },
  },
  created() {
    console.log(this.$route.params)
    if (this.$route.params.siteId === null) {
      this.siteYes = false
    } else {
      this.siteYes = true
    }
  },
}
</script>
